module.exports = __webpack_public_path__ + "img/published-2-min.e6c3846f.png";